import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

const TOKEN_KEY = 'resto_auth_token';

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common.Authorization;
  }
}

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY);
}

// Initialize header from storage on module load
const _stored = getAuthToken();
if (_stored) {
  api.defaults.headers.common.Authorization = `Bearer ${_stored}`;
}

// Auto-redirect to /login on 401 (except during login itself)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err?.config?.url || '';
      if (!url.includes('/auth/login') && !url.includes('/auth/me')) {
        setAuthToken(null);
        if (window.location.pathname !== '/login') {
          window.location.href = '/login?session=expired';
        }
      }
    }
    return Promise.reject(err);
  },
);

// Append Bearer token to PDF/image URLs as a query param fallback (for inline iframes)
export const apiPdfUrl = (path) => {
  const token = getAuthToken();
  const sep = path.includes('?') ? '&' : '?';
  return `${API_BASE}${path}${token ? `${sep}_t=${encodeURIComponent(token)}` : ''}`;
};
